import logo from "assets/images/logo/Trellis_Logomark_color.png";
import axios from "axios";
import { Button } from "components/core/basic/Button";
import { Component } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import getURLPrefix from "utils/getUrlPrefix";
import { SUBSCRIPTION_PLANS_UPPERCASE } from "utils/onboardingConstants";
import * as Sentry from "@sentry/react";
import api from "utils/api";
import checkModule from "utils/checkModule";
import { withStyles } from "@material-ui/core";
import withMediaQuery from "hocs/withMediaQuery";
import { selectModules } from "redux/selectors/modules";
import { formatCurrency } from "utils/formatNumber";
import { css } from "../../../../styled-system/css";
import { Flex } from "../../../../styled-system/jsx";
import Loading from "components/core/blocks/Loading";

const subscriptionPlans = SUBSCRIPTION_PLANS_UPPERCASE;

const URL_PREFIX = getURLPrefix();

const useStyles = (theme) => ({
  corporateCardRadio: {
    marginLeft: "3rem",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "2rem",
    },
  },
  corporateCardImage: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      paddingLeft: "1rem",
    },
  },
  corporateCardBody: {
    [theme.breakpoints.down("sm")]: {
      marginLeft: "-45px",
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: "-25px",
    },
  },
  corporateCardHeader: {
    textAlign: "center",
    color: "#D91266",
    fontSize: "16px",
    fontWeight: 500,
    margin: "2rem 0 2rem -8rem",
  },
  [theme.breakpoints.down("sm")]: {
    justifyContent: "flex-start",
    marginLeft: "-4rem",
  },
  mobileCardStyles: {
    flexDirection: "column",
    "@media (max-width:1270px)": {
      flexDirection: "row",
    },
  },
});

class SubscriptionPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subList: [],
      subName: "",
      signUpDate: "",
      subSuccessful: false,
      reactivateActive: false,
      error: {},
      changePlanModal: !!this.props.location?.state?.showModal,
      currentTier: "",
      currentPricingTier: "",
      currentAnalyticsTier: "",
      upgradedSubscriptionPlanName: "",
      upgradedPricingSubscriptionPlanName: "",
      upgradedAnalyticsSubscriptionPlanName: "",
      subscriptionPlan: null,
      pricingSubscriptionPlan: null,
      analyticsSubscriptionPlan: null,
      subscriptionPlanName: "",
      pricingSubscriptionPlanName: "",
      analyticsSubscriptionPlanName: "",
      payAmount: "",
      payPlan: "",
      pricingPayPlan: "",
      analyticsPayPlan: "",
      payFrequency: "",
      upgradedPayPlan: "",
      upgradedPricingPayPlan: "",
      upgradedAnalyticsPayPlan: "",
      monthlyChecked: true,
      numOfShelves:
        this.props.location?.state?.numOfShelves ?
          this.props.location?.state?.numOfShelves
        : this.props.currentNumOfShelves,
      currentNumOfShelves:
        this.props.location?.state?.numOfShelves ?
          this.props.location?.state?.numOfShelves
        : this.props.currentNumOfShelves,
      monthlyShelfFee: checkModule(this.props.modules, "SEARCH_ANALYTICS") ? this.props.monthlyShelfFee : 0,
      includedShelves: 0,
      numOfActiveShelves: 0,
      upgradeTarget: "advertising",
    };
  }

  fetchActiveShelfCount = async () => {
    try {
      const res = await api.get("/api/shelves");
      this.setState({ numOfActiveShelves: res.data.count });
    } catch (e) {
      Sentry.captureException(e);
    }
  };

  componentDidMount() {
    if (
      this.props.amz_onboard.org_status === "trial_active" ||
      this.props.amz_onboard.org_status === "trial_expired" ||
      this.props.amz_onboard.org_status === "pre_trial"
    ) {
      // do nothing
    } else {
      this.getSubscriptionList();
      this.getSubscriptionName();
      this.getSignUpDate();

      if (checkModule(this.props.modules, "SEARCH_ANALYTICS")) {
        this.fetchActiveShelfCount();
      }
    }
  }

  componentDidUpdate() {
    // Update current shelf subscription data in case not ready prior to initial render
    if (
      (checkModule(this.props.modules, "SEARCH_ANALYTICS") &&
        this.state.currentNumOfShelves !== this.props.currentNumOfShelves) ||
      this.state.monthlyShelfFee !== this.props.monthlyShelfFee
    ) {
      this.setState({
        currentNumOfShelves: this.props.currentNumOfShelves,
        numOfShelves: this.props.currentNumOfShelves,
        monthlyShelfFee: this.props.monthlyShelfFee,
      });
    }
  }

  getSignUpDate = () => {
    axios
      .get(URL_PREFIX + "/api/billing/plan")
      .then((res) => {
        this.setState({ signUpDate: res.data.sign_up_date });
      })
      .catch((error) => {
        if (error?.response?.status !== 400) {
          Sentry.captureException(error);
        }
      });
  };

  getDisplayName = (tier) => {
    const display = SUBSCRIPTION_PLANS_UPPERCASE[tier.split("__")?.[0]]?.displayName;

    return display ?? "Custom";
  };
  getSubscriptionName = () => {
    axios.get(URL_PREFIX + "/api/aboutyourcompany").then((res) => {
      if (res.data.tier.startsWith("PRO") || res.data.tier.startsWith("CORE_PRO")) {
        this.setState(
          {
            subName: "Professional",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: checkModule(this.props.modules, "SEARCH_ANALYTICS") ? 3 : 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("ENTER")) {
        this.setState(
          {
            subName: "Enterprise",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: checkModule(this.props.modules, "SEARCH_ANALYTICS") ? 3 : 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("ENTREPREN") || res.data.tier.startsWith("CORE_ENTRE")) {
        this.setState(
          {
            subName: "Entrepreneur",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("CORE_GROWTH")) {
        this.setState(
          {
            subName: "Growth",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("BUSINESS")) {
        this.setState(
          {
            subName: "Business",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: checkModule(this.props.modules, "SEARCH_ANALYTICS") ? 2 : 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("CORE_CUSTOM")) {
        this.setState(
          {
            subName: "Custom",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.tier.startsWith("CORPORATE")) {
        this.setState(
          {
            subName: "Corporate",
            currentTier: res.data.tier,
            currentPricingTier: res.data.pricing_tier,
            currentAnalyticsTier: res.data.analytics_tier,
            currentContentTier: res.data.content_tier,
            includedShelves: 0,
          },
          () => {
            this.extractSubscription();
          },
        );
      }

      // Get pricing subscription name
      if (res.data.pricing_tier.startsWith("BUSINESS")) {
        this.setState(
          {
            pricingSubName: "Starter",
            currentPricingTier: res.data.pricing_tier,
            upgradedPricingSubscriptionPlanName: res.data.pricing_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.pricing_tier.startsWith("ENTER")) {
        this.setState(
          {
            pricingSubName: "Enterprise",
            currentPricingTier: res.data.pricing_tier,
            upgradedPricingSubscriptionPlanName: res.data.pricing_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.pricing_tier.startsWith("ENTREPREN")) {
        this.setState(
          {
            pricingSubName: "Entrepreneur",
            currentPricingTier: res.data.pricing_tier,
            upgradedPricingSubscriptionPlanName: res.data.pricing_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      }

      // Get analytics subscription name
      if (res.data.analytics_tier.startsWith("FREE")) {
        this.setState(
          {
            analyticsSubName: "Free",
            currentAnalyticsTier: res.data.analytics_tier,
            upgradedAnalyticsSubscriptionPlanName: res.data.analytics_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.analytics_tier.startsWith("ENTER")) {
        this.setState(
          {
            analyticsSubName: "Enterprise",
            currentAnalyticsTier: res.data.analytics_tier,
            upgradedAnalyticsSubscriptionPlanName: res.data.analytics_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.analytics_tier.startsWith("ENTREPREN")) {
        this.setState(
          {
            analyticsSubName: "Entrepreneur",
            currentAnalyticsTier: res.data.analytics_tier,
            upgradedAnalyticsSubscriptionPlanName: res.data.analytics_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      } else if (res.data.analytics_tier.startsWith("PRO")) {
        this.setState(
          {
            analyticsSubName: "Professional",
            currentAnalyticsTier: res.data.analytics_tier,
            upgradedAnalyticsSubscriptionPlanName: res.data.analytics_tier,
          },
          () => {
            this.extractSubscription();
          },
        );
      }
    });
  };

  extractSubscription() {
    const { currentTier, currentPricingTier } = this.state;
    const plan = currentTier.split("__");
    const pricingPlan = currentPricingTier?.split("__");
    if (plan[1] === "ANNUAL") {
      if (this.state.upgradeTarget === "pricing") {
        this.setState({
          pricingSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          pricingSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedPricingSubscriptionPlanName: pricingPlan[0]?.annual?.["plan"],
          monthlyChecked: false,
        });
      } else if (this.state.upgradeTarget === "search-analytics") {
        this.setState({
          analyticsSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          analyticsSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedAnalyticsSubscriptionPlanName: pricingPlan[0]?.annual?.["plan"],
          monthlyChecked: false,
        });
      } else if (this.state.upgradeTarget === "content") {
        this.setState({
          analyticsSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          analyticsSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedContentSubscriptionPlanName: pricingPlan[0]?.annual?.["plan"],
          monthlyChecked: false,
        });
      } else {
        this.setState({
          pricingSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          pricingSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: plan[1],
          payAmount: subscriptionPlans[plan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedSubscriptionPlanName: plan[0],
          monthlyChecked: false,
        });
      }
    } else if (plan[1] === "MONTHLY") {
      if (this.state.upgradeTarget === "pricing") {
        this.setState({
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          pricingSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          pricingSubscriptionPlanName: pricingPlan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.monthly["pay"],
          payPlan: subscriptionPlans[plan[0]]?.monthly["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.monthly["plan"],
          upgradedPricingSubscriptionPlanName: pricingPlan[0],
          monthlyChecked: true,
        });
      } else if (this.state.upgradeTarget === "search-analytics") {
        this.setState({
          analyticsSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          analyticsSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedAnalyticsSubscriptionPlanName: pricingPlan[0],
          monthlyChecked: true,
        });
      } else if (this.state.upgradeTarget === "content") {
        this.setState({
          analyticsSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          analyticsSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: pricingPlan[1],
          payAmount: subscriptionPlans[pricingPlan[0]]?.annual?.["pay"],
          payPlan: subscriptionPlans[plan[0]]?.annual?.["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.annual?.["plan"],
          upgradedContentSubscriptionPlanName: pricingPlan[0],
          monthlyChecked: true,
        });
      } else {
        this.setState({
          pricingSubscriptionPlan: subscriptionPlans[pricingPlan[0]],
          pricingSubscriptionPlanName: pricingPlan[0],
          subscriptionPlan: subscriptionPlans[plan[0]],
          subscriptionPlanName: plan[0],
          payFrequency: plan[1],
          payAmount: subscriptionPlans[plan[0]]?.monthly["pay"],
          payPlan: subscriptionPlans[plan[0]]?.monthly["plan"],
          pricingPayPlan: subscriptionPlans[pricingPlan[0]]?.monthly["plan"],
          upgradedSubscriptionPlanName: plan[0],
          monthlyChecked: true,
        });
      }
    }
  }

  getSubscriptionList = () => {
    axios.get(URL_PREFIX + "/api/billing/subscription").then((res) => {
      this.setState({ subList: res.data.subscriptions.data });
    });
  };

  handleReactivateButton = () => {
    this.setState({ reactivateActive: true });
    const AuthHeader = "Bearer ".concat(this.props.auth.tokens.access_token);

    axios
      .post(
        URL_PREFIX + "/api/billing/subscription",
        {
          initialSubscriptionType: "advertising",
        },
        {
          params: {},
          headers: { Authorization: AuthHeader },
        },
      )
      .then((result) => {
        // The card had an error when trying to attach it to a customer.
        if (result.error) {
          this.setState({
            error: {
              title: "Card Declined",
              message: "Payment failed. Please try adding a new active card.",
            },
            reactivateActive: false,
          });
        }
        return result;
      })
      .then((result) => {
        // Normalize the result to contain the object returned by Stripe.
        // Add the addional details we need.
        if (result.data.status === "User already subscribed.") {
          this.setState({
            error: {
              title: "User Already Subscribed",
              message: "Your organization is already subscribed.",
            },
          });
          throw new Error("User already subscribed.");
        }

        if (result.data.status === "Subscription in retry state.") {
          localStorage.setItem("latestInvoiceId", result.data.invoice.id);
          localStorage.setItem("latestInvoicePaymentIntentStatus", result.data.invoice.payment_intent.status);

          this.retryInvoiceWithNewPaymentMethod();

          return {
            subscription: "break",
          };
        }

        if (result.data.subscription.status === "active" || result.data.subscription.status === "trialing") {
          this.setState({ subSuccessful: true });
          window.location.reload();
        }

        return {
          subscription: result,
        };
      })
      // Some payment methods require a customer to be on session
      // to complete the payment process. Check the status of the
      // payment intent to handle these actions.
      // .then(this.handlePaymentThatRequiresCustomerAction)
      // If attaching this card to a Customer object succeeds,
      // but attempts to charge the customer fail, you
      // get a requires_payment_method error.
      .then(this.handleRequiresPaymentMethod)
      // No more actions required. Provision your service for the user.
      .catch(() => {
        this.setState({
          error: {
            title: "Please try again",
            message: "Something went wrong while updating subscription status.",
          },
          reactivateActive: false,
        });
      });
  };

  handleRequiresPaymentMethod = ({ subscription }) => {
    if (!(subscription === "break")) {
      const tempSubscription = subscription.data.subscription;
      if (
        tempSubscription.latest_invoice.payment_intent !== null &&
        tempSubscription.latest_invoice.payment_intent.status !== null
      ) {
        if (tempSubscription.latest_invoice.payment_intent.status === "requires_payment_method") {
          localStorage.setItem("latestInvoiceId", tempSubscription.latest_invoice.id);
          localStorage.setItem(
            "latestInvoicePaymentIntentStatus",
            tempSubscription.latest_invoice.payment_intent.status,
          );
          this.setState({
            error: {
              title: "Payment Failed",
              message: "Please try a new payment method.",
            },
            reactivateActive: false,
          });
        }
      }
    }
  };

  retryInvoiceWithNewPaymentMethod() {
    const paymentInfo = {
      invoiceId: localStorage.getItem("latestInvoiceId"),
    };

    localStorage.removeItem("latestInvoiceId");
    localStorage.removeItem("latestInvoicePaymentIntentStatus");

    const AuthHeader = "Bearer ".concat(this.props.auth.tokens.access_token);

    return axios
      .post(URL_PREFIX + "/api/billing/retrysubscription", paymentInfo, {
        params: {},
        headers: { Authorization: AuthHeader },
      })
      .then((result) => {
        if (result.error) {
          this.setState({
            error: {
              title: "Improper Card Info",
              message: "Please try a new payment method.",
            },
          });
          throw result;
        }
        return result;
      })
      .then((result) => {
        if (result.data.status === "User already subscribed.") {
          this.setState({
            error: {
              title: "User Already Subscribed",
              message: "Your organization is already subscribed",
            },
          });
          throw new Error("User already subscribed.");
        }

        if (result.data.subscription.status === "active" || result.data.subscription.status === "trialing") {
          this.setState({ subSuccessful: true });
          window.location.reload();
        }

        return {
          subscription: result,
        };
      })
      .then(this.handleRequiresPaymentMethod)
      .catch(() => {
        this.setState({
          error: {
            title: "Improper Card Info",
            message: "Please try a new payment method.",
          },
          reactivateActive: false,
        });
      });
  }

  render() {
    const { classes } = this.props;
    withMediaQuery((theme) => theme.breakpoints.down("sm"), {
      defaultMatches: true,
    });

    return (
      <div className="card " style={{ paddingBottom: "15px", fontSize: "13px" }}>
        <Row
          className="text-center pt-4 px-2"
          style={{
            marginBottom: "0rem",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          <p style={{ marginTop: "1rem", fontSize: "20px", fontWeight: 600 }}>Plan Details</p>
        </Row>
        {(
          this.state.subList.length !== 0 &&
          this.props.amz_onboard.org_status !== "disconnected" &&
          !this.props.amz_onboard.remainder_days
        ) ?
          <Row
            style={{
              overflowY: "auto",
              marginLeft: "0px",
              marginRight: "0px",
            }}
            className="fs-standard"
          >
            <Row className="d-flex justify-content-center" style={{ marginLeft: "0px", marginRight: "0px" }}>
              {this.props.user.tier && this.props.user.tier !== "unknown" && (
                <Col xs={12} md={10} className="text-center" style={{ marginTop: "1rem" }}>
                  You are currently registered for the <b>{this.getDisplayName(this.props.user.tier)}</b> Advertising
                  subscription, which began on <b>{this.state.signUpDate}</b>.
                </Col>
              )}
              {this.props.user.pricing_tier && this.props.user.pricing_tier !== "unknown" && (
                <Col md={10} mdOffset={1} className="text-center" style={{ marginTop: "1rem" }}>
                  You are currently registered for the <b>{this.getDisplayName(this.props.user.pricing_tier)} </b>{" "}
                  Dynamic Pricing subscription.
                </Col>
              )}
              {this.props.user.analytics_tier && this.props.user.analytics_tier !== "unknown" && (
                <Col md={10} mdOffset={1} className="text-center" style={{ marginTop: "1rem" }}>
                  You are currently registered for the <b>{this.getDisplayName(this.props.user.analytics_tier)} </b>{" "}
                  Search Analytics subscription.
                </Col>
              )}
              {this.props.user.content_tier && this.props.user.content_tier !== "unknown" && (
                <Col md={10} mdOffset={1} className="text-center" style={{ marginTop: "1rem" }}>
                  You are currently registered for the <b>Standard</b> Content subscription.
                </Col>
              )}
            </Row>
            <Row className="d-flex justify-content-center" style={{ marginLeft: "0px", marginRight: "0px" }}>
              <Col
                md={8}
                mdOffset={2}
                className="text-center"
                style={{
                  textTransform: "capitalize",
                  marginBottom: "2rem",
                }}
              >
                <Row style={{ marginTop: "1rem" }}>
                  <Col className="d-flex justify-content-center">
                    <strong className="pe-2">Payment Frequency:</strong>
                    {this.state.subList[0].items.data[0].plan.interval}ly
                  </Col>
                </Row>
                <Row style={{ marginTop: "1rem" }}>
                  <Col className="d-flex justify-content-center">
                    <strong className="pe-2">You Pay: </strong>
                    {formatCurrency(
                      this.state.subList[0].items.data.reduce(
                        (prev, subItem) => prev + (subItem.plan.amount * (subItem.quantity ?? 1)) / 100,
                        0,
                      ),
                      // Defaulting to USA to align with Stripe currency (always USDs)
                      "USA",
                      true,
                    )}
                  </Col>
                </Row>
                {checkModule(this.props.modules, "SEARCH_ANALYTICS") && (
                  <Row style={{ marginTop: "1rem" }}>
                    <Col className="d-flex justify-content-center">
                      <strong className="pe-2">Shelf count: </strong>
                      {this.state.numOfActiveShelves}/{this.state.currentNumOfShelves}
                    </Col>
                  </Row>
                )}

                <Row className="d-flex justify-content-center" style={{ marginTop: "2rem" }}>
                  <Button
                    onPress={() => {
                      this.setState({ changePlanModal: true });
                    }}
                    className={css({ width: "85%", maxWidth: "85%" })}
                  >
                    Change Plan
                  </Button>
                </Row>
              </Col>
            </Row>
          </Row>
        : null}
        {(
          this.props.amz_onboard.org_status === "disconnected" ||
          this.props.amz_onboard.remainder_days !== null ||
          this.props.subscriptionCancelled
        ) ?
          <Row
            style={{
              height: "225px",
              marginLeft: "0px",
              marginRight: "0px",
            }}
          >
            <Col xs={12} md={{ span: 8, offset: 2 }} className="text-center" style={{ marginTop: "2rem" }}>
              Your subscription is currently <b>cancelled</b>.
              {this.props.amz_onboard.remainder_days !== null ?
                <span> You have {this.props.amz_onboard.remainder_days} paid days left. </span>
              : null}
            </Col>
            <Col
              xs={12}
              md={{ span: 8, offset: 2 }}
              style={{ marginBottom: "4rem", display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              {!this.state.reactivateActive ?
                <Button disabled={false} onPress={() => this.handleReactivateButton()}>
                  Reactivate with Trellis
                </Button>
              : <img src={logo} alt="Loading..." className="rotate" width="80" height="auto" />}
            </Col>
          </Row>
        : null}
        {this.props.amz_onboard.org_status === "payment_required" ?
          <Row>
            <Col xs={12} md={{ span: 8, offset: 2 }} className="text-center" style={{ marginBottom: "2rem" }}>
              <b> Your account requires a new payment method.</b>
            </Col>
          </Row>
        : null}
        {this.state.error.title !== undefined ?
          <SweetAlert
            title={this.state.error.title}
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.setState({ error: {} })}
          >
            {this.state.error.message}
          </SweetAlert>
        : null}
        <div style={{ width: "100%" }}>
          <Modal
            show={this.state.changePlanModal}
            onHide={() => this.setState({ changePlanModal: false })}
            className={classes.subscriptionModal}
            centered="true"
          >
            <Modal.Body>
              {this.state.loading ?
                <Row>
                  <Loading height={"70vh"} fullPage={false} />;
                </Row>
              : <div style={{ padding: "1rem 2rem" }}>
                  <Row>
                    <span
                      onClick={() => this.setState({ changePlanModal: false })}
                      style={{
                        fontSize: "26px",
                        color: "lightgray",
                        fontWeight: "100",
                        float: "right",
                        cursor: "pointer",
                        textAlign: "end",
                      }}
                    >
                      &#10005;
                    </span>
                  </Row>

                  {this.state.changePlanModal ?
                    <Flex justifyContent={"center"} direction={"column"} gap={"large"} alignItems={"center"}>
                      <p className={css({ textAlign: "center" })}>
                        Please reach out to Trellis's customer success team to change your subscription plan.
                      </p>
                      <Button
                        onPress={() => {
                          window.location = "mailto:support@gotrellis.com";
                        }}
                      >
                        Contact Us
                      </Button>
                    </Flex>
                  : null}
                </div>
              }
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  marketPlace: state.marketPlace,
  amz_onboard: state.amz_onboard,
  user: state.user,
  modules: selectModules(state),
});

export default connect(mapStateToProps)(
  withRouter(withStyles(useStyles)(withMediaQuery("(max-width:740px)")(SubscriptionPlan))),
);
